// StudentModal.js
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';

const StudentResultModal = ({ show, handleClose, studentData }) => {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{studentData?.student.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p><strong>رقم الهاتف:</strong> {studentData?.student.phone_number}</p>
                    <h5>تفاصيل:</h5>
                    {studentData?.records.map(record => (
                        <div key={record.id} className="card mb-2">
                            <div className="card-body">
                                <p><strong>المدرس:</strong>
                                    <Link className='p-2' to={`/instructor-records/${record.instructor.id}`} onClick={handleClose}>
                                    <Button variant='info'>{record.instructor.name}</Button>
                                    
                                    </Link>
                                </p>
                                <p><strong>المادة:</strong> {record.subject.name}</p>
                                {/* <p><strong>المبلغ:</strong> {record.amount}</p>
                <p><strong>عدد الحصص:</strong> {record.num_classes}</p>
                <p><strong>حالة الطالب:</strong> {record.student_status}</p> */}

                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default StudentResultModal;